export default __webpack_public_path__ + "static/media/port6.589f7105.png";